import { CalendarDays, Briefcase, House, Inbox, Plus } from 'lucide-react';
import { NavLink } from 'react-router';
import { Sheet } from '@/design-system/components/sheet';
import { cn } from '@/lib/utils';
import { usePalette } from './command-palette';
import { SidebarContent } from './sidebar';
import { useSidebar } from './sidebar-store';

const TABS = [
  { to: '/', label: 'Home', icon: House },
  { to: '/inbox', label: 'Inbox', icon: Inbox },
  { to: '/clients', label: 'Clientes', icon: Briefcase },
  { to: '/calendar', label: 'Agenda', icon: CalendarDays },
];

/** Mobile (SPEC §46): menu completo em drawer + barra inferior com os destinos mais usados. */
export function MobileNav() {
  const { mobileOpen, setMobileOpen } = useSidebar();
  const openPalette = usePalette((s) => s.setOpen);
  return (
    <>
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen} side="left" title="Menu">
        <SidebarContent onNavigate={() => setMobileOpen(false)} />
      </Sheet>
      <nav
        aria-label="Atalhos"
        className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-5 border-t border-line bg-canvas/92 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
      >
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'flex h-15 flex-col items-center justify-center gap-1 text-[11px]',
                isActive ? 'text-fg' : 'text-fg-subtle',
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon className="size-5" strokeWidth={1.75} />
                <span>{label}</span>
                <span className={cn('h-[3px] w-4 rounded-full', isActive ? 'bg-signal' : 'bg-transparent')} />
              </>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={() => openPalette(true)}
          className="flex flex-col items-center justify-center gap-1 text-[11px] text-fg-subtle"
          aria-label="Criar ou buscar"
        >
          <span className="flex size-8 items-center justify-center rounded-full bg-signal text-signal-fg">
            <Plus className="size-5" />
          </span>
        </button>
      </nav>
    </>
  );
}
